export const breakpoints = {
  desktop: 1024,
  tablet: 768,
}



// WEBPACK FOOTER //
// ./src/utils/theme/breakpoints.ts